import React, { useState, useEffect } from "react";
import SearchForm from "../search-form";
import CheckboxFilter from "../Filter/CheckboxFilter";
import SimpleBarReact from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import useDebounce from "../../Hook/useDebounce";
import { useSelector, useDispatch } from "react-redux";
import ReusableComponentCard from "./ReusableComponentCard";
import {
  SET_TEMPLATE_PREVIEW_DATA,
  SAVE_TEMPORARY_DATA,
} from "../../redux/constants/index";
import { useLocation, useNavigate } from "react-router-dom";
import { sanitizeInput } from "../../utils";

function ReusableComponent({ setShowWatermark }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname, state } = location;
  const { componentListData } = useSelector((state) => state.manageComponent);
  const { componentGridLayoutData } = useSelector(
    (state) => state.bookingTemplate
  );

  const [searchText, setSearchText] = useState();
  const [searchData, setSearchData] = useState([]);

  // Use the debounce hook to get the debounced version of the handleSearch function
  const debouncedHandleSearch = useDebounce(searchText, 300);

  /* ------------------- Checkbox Data ----------------- */
  const [checkboxData, setCheckboxData] = useState({
    "Component Type": [
      {
        label: "Text",
        value: "text",
        checked: false,
      },
      {
        label: "Number",
        value: "number",
        checked: false,
      },
      {
        label: "Date/Time",
        checked: false,
        value: "date/time",
      },
      {
        label: "Dropdown",
        checked: false,
        value: "dropdown",
      },
      {
        label: "Checkbox",
        checked: false,
        value: "check box",
      },
      {
        label: "Paragraph",
        checked: false,
        value: "paragraph",
      },
      {
        label: "Link",
        checked: false,
        value: "link",
      },
      {
        label: "Radio Group",
        checked: false,
        value: "radio group",
      },
      {
        label: "Toggle",
        checked: false,
        value: "toggle",
      },
    ],
  });

  const handleCheckboxChange = (index, key) => {
    const updatedData = { ...checkboxData };
    updatedData[key][index].checked = !updatedData[key][index].checked;
    setCheckboxData(updatedData);
  };

  const handleSearchAndFilter = (searchQuery, listData) => {
    if (listData.length > 0 && searchQuery) {
      const searchResult = listData.filter((obj) =>
        obj.label.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setSearchData(searchResult);
    } else {
      setSearchData(listData);
    }
  };

  useEffect(() => {
    const filteredData = componentListData.filter((item) => {
      const typeChecked = checkboxData["Component Type"].some(
        (checkbox) => checkbox.value === item.type && checkbox.checked
      );
      return typeChecked;
    });

    if (filteredData.length > 0) {
      handleSearchAndFilter(debouncedHandleSearch, filteredData);
    } else if (
      checkboxData["Component Type"].some((checkbox) => checkbox.checked)
    ) {
      handleSearchAndFilter(debouncedHandleSearch, []);
    } else {
      handleSearchAndFilter(debouncedHandleSearch, componentListData);
    }
  }, [debouncedHandleSearch, checkboxData, componentListData]);

  // Function to get different icon
  const getIcon = (type, isChecked) => {
    const iconMapping = {
      text: "fas fa-text",
      dropdown: "fas fa-caret-square-down",
      toggle: "fas fa-toggle-on",
      "date/time": "far fa-calendar",
      "check box": "fas fa-check-square",
      link: "fas fa-link",
      "radio group": "fa-solid fa-circle-dot",
      paragraph: "fa-solid fa-p",
      number: "fa-solid fa-n",
      stakeholder: "fa-solid fa-user"
    };

    const iconClass = iconMapping[type.toLowerCase()];

    if (iconClass) {
      return (
        <span className={`${iconClass} ${isChecked && "text-white"}`}></span>
      );
    } else {
      return null;
    }
  };

  const handleDragStart = (event, item) => {
    setShowWatermark(false);
  };

  const handleDragEnd = () => {
    if (componentGridLayoutData.length === 0) {
      setShowWatermark(true);
    }
  };

  const renderComponentCards = (data) => {
    // return data.length > 0 ? (
    //   data.map((item, index) => (
    //     <ReusableComponentCard
    //       key={index}
    //       index={index}
    //       item={item}
    //       getIcon={getIcon}
    //       handleDragStart={handleDragStart}
    //       handleDragEnd={handleDragEnd}
    //     />
    //   ))
    // ) : (
    //   <h2 className="text-center font-semibold">No results found</h2>
    // );
    return <>
      {pathname.includes("activity") && (
        <div>   
          {data?.length > 0 ? (
            <div className="space-y-2">
              <p className="font-inter font-semibold text-sm text-[#9297A2]">Shiperone Default Components</p>
              {
                data?.filter(item => item.default_component_type === "stakeholder").map((item, index) => (
                  <ReusableComponentCard
                    key={index}
                    index={index}
                    item={item}
                    getIcon={getIcon}
                    handleDragStart={handleDragStart}
                    handleDragEnd={handleDragEnd}
                  />
                ))
              }
              {data?.filter(item => item.default_component_type === "stakeholder")?.length === 0 && <h2 className="py-3 text-center font-normal italic text-[13px] text-[#535860]">No Shiperone Default Components Found.</h2>}
              
            </div>
          ) : (
            <h2 className="py-3 text-center font-normal italic text-[13px] text-[#535860]">No Shiperone Default Components available.</h2>
          )}
        </div>
      )}
      
      <div>
        {data?.length > 0 ? (
          <div className="space-y-2">
            <p className="font-inter font-semibold text-sm text-[#9297A2]">Your Components</p>
            {
              data?.filter(item => item.default_component_type !== "stakeholder").map((item, index) => (
                <ReusableComponentCard
                  key={index}
                  index={index}
                  item={item}
                  getIcon={getIcon}
                  handleDragStart={handleDragStart}
                  handleDragEnd={handleDragEnd}
                />
              ))
            }
            {data?.filter(item => item.default_component_type !== "stakeholder").length === 0 && <h2 className="py-3 text-center font-normal italic text-[13px] text-[#535860]">No results found</h2> }
          </div>
        ) : (
          <h2 className="py-3 text-center font-normal italic text-[13px] text-[#535860]">No results found</h2>
        )}
      </div>
    </>
  };

  return (
    <div className="h-screen" style={{ maxHeight: "calc(100vh - 107px)" }}>
      {!pathname.includes("activity") && (
        <h4 className="text-sm leading-3 tracking-tight font-bold text-[#535860] pb-1 border-b border-[#D9D9D9]">
          Components
        </h4>
      )}
      <div className="flex items-center space-x-2 py-2 mt-1">
        <SearchForm
          placeholder="Search"
          formClass="w-full"
          onChange={(e) => {
            const value = sanitizeInput(e.target.value);
            setSearchText(value);
          }}
          value={searchText}
        />
        <CheckboxFilter
          checkboxData={checkboxData}
          handleCheckboxChange={handleCheckboxChange}
        />
      </div>
      <div className="pb-4">
        <button
          className="btn bg-white border border-slate-200 hover:border-slate-300  cursor-pointer text-sm leading-3 tracking-tight w-full"
          onClick={() => {
            const payload = {
              path: location.pathname,
              tempPageName: pathname.includes("activity")
                ? "manage todo"
                : "manage template",
              saveData: {
                data: componentGridLayoutData,
              },
              stepNumber: 2,
            };
            dispatch({ type: SAVE_TEMPORARY_DATA, payload });
            navigate("/component/create", { state });
          }}
        >
          + Create New Component
        </button>
      </div>
      <SimpleBarReact style={{ maxHeight: "calc(100vh - 250px)" }}>
        <div className="mt-1 space-y-4 overflow-x-hidden">
          {renderComponentCards(searchData)}
        </div>
      </SimpleBarReact>
    </div>
  );
}

export default ReusableComponent;
